<script>
  import { _ } from "svelte-i18n";
  let showDetails = false;
  function toggle() {
    showDetails = !showDetails;
  }
  export let menstrualPain = "";

  import Radio from "./Radio.svelte";
</script>

<div class="form-section form-section--paddingless">
  <h3>
    <button
      on:click={toggle}
      type="button"
      class="button-text button-text--chevron-down {showDetails
        ? 'is-toggled'
        : ''}">{$_("dayParameters.form.menstruation.title")}</button
    >
  </h3>
  <div class={showDetails ? "" : "radio-group--default-hide"}>
    <div>
      <div class="radio-group__labels false">
        <span class="radio-group__label radio-group__label--left"
          >{$_("dayParameters.form.menstruation.low")}</span
        ><span class="radio-group__label" /><span
          class="radio-group__label radio-group__label--right"
          >{$_("dayParameters.form.menstruation.high")}</span
        >
      </div>

      <div class="radio-group radio-group--1-10">
        {#each { length: 10 } as _, index}
          <Radio
            bind:group={menstrualPain}
            value={index + 1}
            label="Plager tilknyttet menstruasjonssyklus"
          />
        {/each}
      </div>
    </div>
  </div>
</div>
